import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import * as _ from 'lodash';
import { ProcessService } from 'src/app/modules/instance/services';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-archive-selected-processes',
    templateUrl: './archive-selected-processes.component.html',
    styleUrls: ['./archive-selected-processes.component.scss']
})
export class ArchiveSelectedProcessesComponent implements OnInit {
    @Input()
    processesList: ITaskModel[];

    @Input()
    restore: boolean;

    get processesToArchive(): ITaskModel[] {
        return _.defaultTo(this.processesList, [])
            .filter(process => process.isSelected);
    }

    get isActive(): boolean {
        return !_.isEmpty(this.processesToArchive);
    }

    constructor(
        private readonly dialog: MatDialog,
        private readonly processService: ProcessService
    ) { }

    ngOnInit(): void { }

    async archiveSelectedProcesses() {
        if (!this.isActive) {
            return;
        }

        const removeCount = this.processesToArchive.length;

        const deleteDialogConfig = new MatDialogConfig();
        deleteDialogConfig.autoFocus = true;
        deleteDialogConfig.data = {
            title: `${this.restore ? 'Unarchive' : 'Archive'} Jobs`,
            topContent: `You are going to ${this.restore ? 'unarchive' : 'archive'} ${removeCount} Job${removeCount > 1 ? 's' : ''}. Continue?`
        };

        const recalculateDialogRef = this.dialog
            .open(ConfirmationDialogComponent, deleteDialogConfig);

        recalculateDialogRef.afterClosed()
            .subscribe(confirmed => {
                if (!confirmed) {
                    return;
                }
                const states = _.uniq(
                    this.processesToArchive
                        .map(process => process.state)
                        .filter(state => !!state)
                );

                states.forEach(state => {
                    const processesIds = this.processesToArchive
                        .filter(process => process.state === state)
                        .map(process => process.id);
                    this.processService
                        .archiveAndRemoveProcesses(
                            state,
                            processesIds,
                            this.restore
                        )
                        .subscribe();
                });
            });
    }

}
